import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EColors } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    label: string;
    iconName: IconName;
    isInactive: boolean;
    onClick: () => void;
}

export const FilterListItem = (props: Props): JSX.Element => {
    return (
        <S_FilterListItem
            className={props.className}
            $isInactive={props.isInactive}
            onClick={(e) => {
                props.onClick();
                e.preventDefault();
            }}
        >
            <S_Icon icon={['fal', props.iconName]} />
            <S_Text>{props.label}</S_Text>
        </S_FilterListItem>
    );
};

const S_FilterListItem = styled.div<{ $isInactive: boolean }>`
    display: flex;
    justify-items: center;
    justify-content: left;
    align-items: center;
    cursor: pointer;
    text-align: left;
    padding: 25px 17px;
    background: #fafafa;
    color: ${(props) => (props.$isInactive ? EColors.GREY4 : EColors.ALMOST_BLACK)};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
    border-radius: 7px;
    &:hover {
        background: #eaeaea;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 20px;
    width: 50px;
    margin-right: 10px;
`;

const S_Text = styled.div``;
